<template>
  <div>
    <transition name="modal-fade">
      <div v-if="isModalVisible" class="modal-overlay" @click.self="goBack">
        <div class="modal-content">
          <div class="modal-header">
            <h2>用户注册</h2>
            <el-button circle plain @click="goBack" class="close-btn">
              <i class="el-icon-close"></i>
            </el-button>
          </div>
          
          <div class="form-container">
            <div class="form-item">
              <label for="account">用户名：</label>
              <div class="input-wrapper">
                <el-input
                  id="account"
                  placeholder="4-16位字母、数字、下划线"
                  prefix-icon="el-icon-user-solid"
                  v-model="registerUser.username"
                  class="input-field"
                  @blur="checkAccount()"
                  @focus="showRules('username')">
                </el-input>
                <transition name="fade">
                  <div v-if="showRule === 'username'" class="rule-tooltip">
                    <p>用户名要求：</p>
                    <ul>
                      <li :class="{'valid': isUsernameValid.length}">4-16个字符</li>
                      <li :class="{'valid': isUsernameValid.character}">只能包含字母、数字、下划线</li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>
            
            <div class="form-item">
              <label for="password">密码：</label>
              <div class="input-wrapper">
                <el-input
                  id="password"
                  class="input-field"
                  placeholder="8-12位字母和数字组合"
                  v-model="registerUser.password"
                  show-password
                  @blur="checkPassword()"
                  @focus="showRules('password')">
                </el-input>
                <transition name="fade">
                  <div v-if="showRule === 'password'" class="rule-tooltip">
                    <p>密码要求：</p>
                    <ul>
                      <li :class="{'valid': isPasswordValid.length}">8-12个字符</li>
                      <li :class="{'valid': isPasswordValid.complexity}">必须包含字母和数字</li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>
            
            <div class="form-item">
              <label for="confirm-password">确认密码：</label>
              <div class="input-wrapper">
                <el-input
                  id="confirm-password"
                  class="input-field"
                  placeholder="再次输入密码"
                  v-model="registerUser.password2"
                  show-password
                  @blur="confirmPassword()"
                  @focus="showRules('confirm')">
                </el-input>
                <transition name="fade">
                  <div v-if="showRule === 'confirm'" class="rule-tooltip">
                    <p>确认密码要求：</p>
                    <ul>
                      <li :class="{'valid': isConfirmValid.match}">必须与密码一致</li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>
            
            <div class="form-item">
              <label>性别：</label>
              <el-radio-group v-model="registerUser.sex" class="gender-radio">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </div>
            
            <div class="form-item">
              <label for="email">邮箱：</label>
              <div class="input-wrapper">
                <el-input 
                  id="email"
                  class="input-field"  
                  v-model="registerUser.email" 
                  placeholder="请输入有效邮箱"
                  prefix-icon="el-icon-message"
                  @blur="checkEmail()"
                  @focus="showRules('email')">
                </el-input>
                <transition name="fade">
                  <div v-if="showRule === 'email'" class="rule-tooltip">
                    <p>邮箱要求：</p>
                    <ul>
                      <li :class="{'valid': isEmailValid.format}">有效的邮箱格式</li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>
            
            <div class="form-item">
              <label for="phone">手机号：</label>
              <div class="input-wrapper">
                <el-input
                  id="phone"
                  placeholder="11位有效手机号"
                  prefix-icon="el-icon-mobile-phone"
                  v-model="registerUser.phone"
                  class="input-field"
                  @blur="checkPhone()"
                  @focus="showRules('phone')">
                </el-input>
                <transition name="fade">
                  <div v-if="showRule === 'phone'" class="rule-tooltip">
                    <p>手机号要求：</p>
                    <ul>
                      <li :class="{'valid': isPhoneValid.length}">11位数字</li>
                      <li :class="{'valid': isPhoneValid.format}">有效的手机号格式</li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>
            
            <div class="form-actions">
              <el-button 
                type="primary" 
                class="register-btn" 
                @click="register()"
                :loading="isRegistering"
                :disabled="!isFormValid">
                注册
              </el-button>
              <el-button 
                type="info" 
                class="cancel-btn" 
                @click="goBack()">
                取消
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name:'RegisterPage',
  data() {
    return {
      isModalVisible: false,
      isRegistering: false,
      showRule: '',
      registerUser: {
        username: '',
        password: '',
        password2: '',
        sex: 1,
        email: '',
        phone: '',
        headPicture: 'http://www.wjyzlj.cn/bsPic/defaultHeader.jpg'
      },
      isUsernameValid: {
        length: false,
        character: false
      },
      isPasswordValid: {
        length: false,
        complexity: false
      },
      isConfirmValid: {
        match: false
      },
      isEmailValid: {
        format: false
      },
      isPhoneValid: {
        length: false,
        format: false
      }
    };
  },
  computed: {
    isFormValid() {
      return this.isUsernameValid.length && this.isUsernameValid.character &&
             this.isPasswordValid.length && this.isPasswordValid.complexity &&
             this.isConfirmValid.match &&
             this.isEmailValid.format &&
             this.isPhoneValid.length && this.isPhoneValid.format;
    }
  },
  mounted() {
    this.isModalVisible = true;
  },
  methods: {
    showRules(field) {
      this.showRule = field;
    },
    hideRules() {
      this.showRule = '';
    },
    //校验用户名
    checkAccount() {
      const lengthValid = this.registerUser.username.length >= 4 && this.registerUser.username.length <= 16;
      const charValid = /^[a-zA-Z0-9_]+$/.test(this.registerUser.username);
      
      this.isUsernameValid.length = lengthValid;
      this.isUsernameValid.character = charValid;
      
      if (!this.registerUser.username) {
        this.$message.error('用户名不能为空');
        return;
      }
      
      if (!lengthValid) {
        this.$message.error('用户名长度应为4-16个字符');
        return;
      }
      
      if (!charValid) {
        this.$message.error('用户名只能包含字母、数字和下划线');
        return;
      }
    },
    //校验密码格式
    checkPassword() {
      const lengthValid = this.registerUser.password.length >= 8 && this.registerUser.password.length <= 12;
      const complexityValid = /[A-Za-z]/.test(this.registerUser.password) && /[0-9]/.test(this.registerUser.password);
      
      this.isPasswordValid.length = lengthValid;
      this.isPasswordValid.complexity = complexityValid;
      
      if (!this.registerUser.password) {
        this.$message.error('请输入密码');
        return;
      }
      
      if (!lengthValid) {
        this.$message.error('密码长度应为8-12个字符');
        return;
      }
      
      if (!complexityValid) {
        this.$message.error('密码必须包含字母和数字');
      }
    },
    //确认两次密码是否相同
    confirmPassword() {
      const matchValid = this.registerUser.password === this.registerUser.password2;
      
      this.isConfirmValid.match = matchValid;
      
      if (!this.registerUser.password2) {
        this.$message.error('请确认密码');
        return;
      }
      
      if (!matchValid) {
        this.$message.error('两次密码不一致，请重新输入');
      }
    },
    //检验邮箱地址
    checkEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const formatValid = emailRegex.test(this.registerUser.email);
      
      this.isEmailValid.format = formatValid;
      
      if (!formatValid && this.registerUser.email) {
        this.$message.error('请输入有效的邮箱格式');
      }
    },
    //检验手机号
    checkPhone() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      const formatValid = phoneRegex.test(this.registerUser.phone);
      const lengthValid = this.registerUser.phone.length === 11;
      
      this.isPhoneValid.format = formatValid;
      this.isPhoneValid.length = lengthValid;
      
      if (!lengthValid && this.registerUser.phone) {
        this.$message.error('手机号应为11位数字');
        return;
      }
      
      if (!formatValid && this.registerUser.phone) {
        this.$message.error("请输入有效的手机号");
      }
    },
    //取消返回主页面
    goBack() {
      this.$router.push('/loginPage');
    },
    //注册提交
    register() {
      if (!this.isFormValid) {
        this.$message.error('请填写完整的注册信息并确保格式正确');
        return;
      }
      
      this.isRegistering = true;
      axios.post('http://www.wjyzlj.cn/pet/user/register', this.registerUser)
        .then(response => {
          if (response.data.code == 200) {
            this.$message({
              message: '注册成功',
              type: 'success'
            });
            this.$router.push('/loginPage');
          } else {
            this.$message.error(response.data.msg || '注册失败');
          }
        })
        .catch(error => {
          console.log(error);
          this.$message.error('注册失败，请稍后重试');
        })
        .finally(() => {
          this.isRegistering = false;
        });
    }
  }
}
</script>

<style scoped>
/* 动画效果 */
.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 背景遮罩层 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
}

/* 弹窗内容 */
.modal-content {
  background: white;
  padding: 25px 30px;
  border-radius: 12px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  animation: modal-zoom 0.3s ease;
}

@keyframes modal-zoom {
  from { transform: scale(0.95); }
  to { transform: scale(1); }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.modal-header h2 {
  margin: 0;
  color: #333;
  font-size: 22px;
  font-weight: 500;
}

.close-btn {
  padding: 8px;
  font-size: 16px;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-item {
  display: flex;
  flex-direction: column;
  position: relative;
}

.form-item label {
  margin-bottom: 8px;
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

.input-wrapper {
  position: relative;
}

.input-field {
  width: 100%;
}

.gender-radio {
  margin-top: 8px;
}

.gender-radio >>> .el-radio {
  margin-right: 20px;
}

.rule-tooltip {
  margin-top: 8px;
  padding: 10px 12px;
  background: #f8f8f8;
  border-radius: 4px;
  border-left: 3px solid #409EFF;
}

.rule-tooltip p {
  margin: 0 0 6px 0;
  font-weight: bold;
  color: #409EFF;
  font-size: 13px;
}

.rule-tooltip ul {
  margin: 0;
  padding-left: 0;
  color: #666;
  font-size: 12px;
}

.rule-tooltip li {
  margin-bottom: 4px;
  position: relative;
  list-style-type: none;
  padding-left: 18px;
}

.rule-tooltip li:before {
  content: "•";
  color: #F56C6C;
  position: absolute;
  left: 0;
}

.rule-tooltip li.valid:before {
  content: "✓";
  color: #67C23A;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
}

.register-btn {
  width: 120px;
  height: 40px;
  font-size: 16px;
  background: linear-gradient(135deg, #409EFF, #337ecc);
  border: none;
  transition: all 0.3s;
}

.register-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.register-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cancel-btn {
  width: 120px;
  height: 40px;
  font-size: 16px;
  transition: all 0.3s;
}

.cancel-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .modal-content {
    width: 90%;
    padding: 20px 15px;
  }
  
  .form-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .register-btn, .cancel-btn {
    width: 100%;
  }
}
</style>